import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	useContentByLabelDataQuery,
	type useContentByLabelDataQuery$data,
	type useContentByLabelDataQuery$variables,
} from '@confluence/content-by-label-macro/entry-points/useContentByLabelDataQuery.ts';
import { composeMacroParamsForQuery } from '@confluence/content-by-label-macro/entry-points/composeMacroParamsForQuery.ts';

import type { MacroContentNode, MacroPreloadHandler } from '../preloadMacroData.ts';

/**
 * Preload handler for the content-by-label macro.
 *
 * For a contentbylabel extension node found in the ADF content, this handler
 * builds query variables from the macro parameters and fires the
 * useContentByLabelDataQuery GraphQL query to populate the Relay store.
 */
export const contentByLabelPreloadHandler: MacroPreloadHandler = {
	extensionKey: 'contentbylabel',

	preload: async (node: MacroContentNode): Promise<void> => {
		const macroParams = node.attrs?.parameters?.macroParams;
		const variables = composeMacroParamsForQuery(macroParams);
		if (!variables.cql) {
			return;
		}
		await query<useContentByLabelDataQuery$data, useContentByLabelDataQuery$variables>({
			query: useContentByLabelDataQuery,
			variables,
			context: { single: true },
		});
	},
};
